import { render } from "./OddsTemplateDetails.vue?vue&type=template&id=fcf0e42a&scoped=true"
import script from "./OddsTemplateDetails.vue?vue&type=script&lang=js"
export * from "./OddsTemplateDetails.vue?vue&type=script&lang=js"

import "./OddsTemplateDetails.vue?vue&type=style&index=0&id=fcf0e42a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcf0e42a"]])

export default __exports__